import { canManagePayment } from "../../Config/paymentAccess.js";

export const canAddInvoicePayment = (user) => canManagePayment(user, "add");
